module.exports = __webpack_public_path__ + "static/media/ga.33d27fe1.svg";